import { PlusIcon } from 'assets/icons/PlusIcon'
import React from 'react'
import { Button, Flex } from 'styling/GlobalStyles'
import { useNavigate } from 'react-router-dom'

export const DashboardActions = () => {
  const navigate = useNavigate()
  return (
    <>
      <Button orange width='220' onClick={() => navigate('/procurement/create')}>
        Create purchase request
      </Button>
    </>
  )
}
